import { Table } from 'foundations-components/transitional/components/Table';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SummaryEmptyTable = ({
  children
}) => /*#__PURE__*/_jsxs(Table, {
  hover: false,
  children: [/*#__PURE__*/_jsx("thead", {
    children: /*#__PURE__*/_jsx("tr", {
      children: /*#__PURE__*/_jsx("th", {})
    })
  }), /*#__PURE__*/_jsx("tbody", {
    children: /*#__PURE__*/_jsx("tr", {
      children: /*#__PURE__*/_jsx("td", {
        children: children
      })
    })
  })]
});
export default SummaryEmptyTable;